import Erreur404 from './Erreur404'

export default Erreur404